import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b997f04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info" }
const _hoisted_2 = { class: "message" }
const _hoisted_3 = { class: "btn" }

import { computed } from "vue";
import { Button } from "ant-design-vue";
import CusModal from "@/components/CusModal/index.vue";
import { useLayoutDataStore } from "@/store/layoutData";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const layoutDataStore = useLayoutDataStore();
const hiddenModal = () => {
  layoutDataStore.downlaodBrowserModal = false;
};

const downlaodBrowserModal = computed(
  () => layoutDataStore.downlaodBrowserModal
);

const handleOpenPage = (url: string) => {
  window.open(url);
  hiddenModal();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CusModal, {
    isShow: _unref(downlaodBrowserModal),
    width: "582px",
    keyboard: false,
    "mask-closable": false,
    centered: "",
    onOnClose: hiddenModal,
    class: "browser-info"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("LowerBrowserInfo.info")), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("LowerBrowserInfo.message")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = () => handleOpenPage('https://www.google.com/chrome/'))
        }, _toDisplayString(_ctx.$t("LowerBrowserInfo.downloadChrome")), 1),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = () => handleOpenPage('https://support.apple.com/'))
        }, _toDisplayString(_ctx.$t("LowerBrowserInfo.downloadSafariBrowser")), 1)
      ])
    ]),
    _: 1
  }, 8, ["isShow"]))
}
}

})